// extracted by mini-css-extract-plugin
export default {"tabs":"Style_tabs__hmQAi","active":"Style_active__seJQG","contentWrapper":"Style_contentWrapper__Xkwus"};